import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { openManagedMatDialog } from '@go-modules/utilities';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

export interface CustomParamsDialogData {
	resource_link_id: string;
	context_id: string;
	user_id: string;
	dialogTitleId?: string;
}

@Component({
	selector: 'app-custom-params-dialog',
	templateUrl: './custom-params-dialog.component.html',
	styleUrls: ['./custom-params-dialog.component.scss'],
	standalone: false
})
export class CustomParamsDialogComponent {

	public static open (
		dialog: MatDialog,
		config?: MatDialogConfig<CustomParamsDialogData>
	): MatDialogRef<CustomParamsDialogComponent, void> {
		const dialogTitleId = config?.data?.dialogTitleId ?? CustomParamsDialogComponent.getDialogTitleId();

		return openManagedMatDialog(dialog, CustomParamsDialogComponent, {
			...(config ?? {}),
			data: {
				...(config?.data ?? {}),
				dialogTitleId
			},
			ariaLabelledBy: dialogTitleId
		});
	}

	private static getDialogTitleId (): string {
		return `custom-params-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	}

	public constructor (
		public dialogRef: MatDialogRef<CustomParamsDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: CustomParamsDialogData
	) {
		this.data.dialogTitleId ??= CustomParamsDialogComponent.getDialogTitleId();
	}

	public close () {
		this.dialogRef.close();
	}
}
